import React from 'react';
import PropTypes from 'prop-types';
import IlluEmptySubsidi from '../../components/icons/IlluEmptySubsidi';
import IconAturBesaranSubsidi from '../../components/icons/IconAturBesaranSubsidi';
import styles from './styles.scoped.css';

export default function EmptyStateSubsidi({ onOpenModal }) {
  return (
    <div className={styles.emptyStateContainer}>
      <IlluEmptySubsidi />
      <div className={styles.emptyStateContent}>
        <h3 className={styles.emptyTitle}>
          Belum Ada Data Informasi Besaran Subsidi
        </h3>
        <p className={styles.emptySubtitle}>
          Harap atur informasi besaran subsidi nasional
        </p>
        <button
          className={styles.btnOutlineGreen}
          onClick={onOpenModal}
          type="button"
        >
          <IconAturBesaranSubsidi color="#5E811E" stroke="#fff" />
          <span>Atur Informasi Besaran Subsidi</span>
        </button>
      </div>
    </div>
  );
}

EmptyStateSubsidi.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
};
